import cn from 'classnames'
import { HTMLProps, useLayoutEffect, useRef } from 'react'

// import { IconInfo } from '~/components/icons/IconInfo'
// import { Tooltip, TooltipContent, TooltipTrigger } from '~/components/data-display/tooltip/Tooltip'
// import { ClientOnly } from '@tanstack/react-router'

import { IconPWLogo } from '~/components/icons/IconPWLogo'

import { PowerGlitch } from 'powerglitch'

import { ClientOnly } from '@tanstack/react-router'
import { IconPWLogoStatic } from '~/components/icons/IconPWLogoStatic'

export function HomepageHeaderTitle ({ className }: HTMLProps<HTMLDivElement>)
{
    const t1 = useRef<HTMLHeadingElement>(null)
    const t2 = useRef<HTMLDivElement>(null)

    const settings = {
        'timing': {
            'duration': 10_000,
        },
        'glitchTimeSpan': {
            'start': 0.45,
            'end': 0.55,
        },
        'shake': {
            'velocity': 3,
            'amplitudeX': 0.02,
            'amplitudeY': 0.03,
        },
        'slice': {
            'count': 2,
            'velocity': 10,
            'maxHeight': 0.01,
            'hueRotate': false,
        },
    }

    useLayoutEffect(() =>
    {
        if (!t1.current || !t2.current) {
            return
        }

        PowerGlitch.glitch(t1.current, settings)
        PowerGlitch.glitch(t2.current, settings)

    }, [t1, t2])

    return (
        <div
            className={cn(
                className,
                'relative flex flex-col flex-wrap items-start justify-start gap-3',
                'md:grid md:grid-cols-[max-content_max-content] md:grid-rows-1 md:mx-auto',
                'lg:grid-cols-[max-content_max-content] lg:grid-rows-1 lg:justify-between lg:mx-0',
                'lg:border lg:border-accent/10 lg:border-solid',
                'xl:flex xl:flex-row xl:items-center xl:justify-start xl:gap-5 xl:flex-nowrap',
                // '2xl:flex-row 2xl:items-center 2xl:gap-10 2xl:flex-nowrap',
            )}
        >
            <div className={cn('flex flex-col gap-3 items-start justify-start')}>
                <h1 className={'sr-only'}>privacy.watch</h1>

                <ClientOnly fallback={<IconPWLogoStatic className={cn('h-8 w-46')} />}>
                    <IconPWLogo className={cn('h-8 w-46')} />
                </ClientOnly>

                <p className={cn('font-mono font-light text-sm tracking-tight')}>which coin dominates <br />the privacy market?
                </p>
            </div>

            <div
                className={cn(
                    'px-0 w-full h-auto rounded-lg border border-dashed border-accent/20',
                    'md:border-0 md:h-33',
                    'xl:@max-[82rem]/hpheader:hidden xl:border',
                )}
                aria-hidden={true}
            >
                <div
                    id={`header-eye`}
                    className={cn('w-full h-auto aspect-[97/66]', 'md:w-auto md:h-full')}
                >
                </div>
            </div>

            {/*<h1*/}
            {/*    className={cn('text-[8vw] font-semibold tracking-tight', 'md:text-5xl md:leading-[normal]')}*/}
            {/*    ref={t1}*/}
            {/*>privacy.<br/>watch*/}
            {/*</h1>*/}

            {/*<div*/}
            {/*    className={cn(*/}
            {/*        'text-[8vw] font-semibold tracking-tight leading-[50%]',*/}
            {/*        'md:text-5xl md:leading-[normal]',*/}
            {/*    )}*/}
            {/*    aria-hidden={true}*/}
            {/*    ref={t2}*/}
            {/*>.watch*/}
            {/*</div>*/}

            {/*<RowDescription*/}
            {/*    className={cn('hidden', 'md:flex', 'lg:ms-auto lg:justify-self-end', 'xl:hidden', '2xl:flex')}*/}
            {/*>Privacy, or Anonymity Enhanced Coins (AECs).</RowDescription>*/}

            {/*<RowDescription*/}
            {/*    className={cn('hidden', 'md:flex', 'lg:ms-auto lg:justify-self-end', 'xl:hidden', '2xl:flex')}*/}
            {/*>Value of all mined coins.</RowDescription>*/}

            {/*<ClientOnly> <Tooltip>*/}

            {/*    <TooltipTrigger*/}
            {/*        className={cn(*/}
            {/*            'absolute top-4 right-4',*/}
            {/*            'inline-block ms-auto justify-self-end',*/}
            {/*            'md:hidden',*/}
            {/*            'xl:block xl:top-6 xl:right-6',*/}
            {/*            '2xl:hidden',*/}
            {/*        )}*/}
            {/*    > <span className={cn('sr-only')}>What is Privacy Watch?</span> <IconInfo*/}
            {/*        className={cn('w-3.5 h-3.5 text-accent/40')}*/}
            {/*    /> </TooltipTrigger>*/}

            {/*    <TooltipContent>*/}
            {/*        <div className={'tooltip w-full'}>*/}
            {/*            Privacy stands for Privacy Coins, or Anonymity Enhanced Coins (AECs).<br /><br />Market Cap is a value of all mined coins. Calculated by multiplying current price by circulating supply.*/}
            {/*        </div>*/}
            {/*    </TooltipContent>*/}

            {/*</Tooltip> </ClientOnly>*/}
        </div>
    )
}

function RowDescription ({
    className,
    children,
}: HTMLProps<HTMLDivElement>)
{
    return (
        <div className={cn(className, 'h-full grow-0 flex flex-row items-center gap-3')}>
            <div
                className={cn(
                    'h-full w-1.5 border-dashed border-y border-e border-accent/50',
                    'md:h-4/5',
                    'lg:w-[1px] lg:h-2/4',
                    '2xl:w-1.5 2xl:h-4/5',
                )}
                aria-hidden={true}
            ></div>
            <p className={cn('self-center w-50 text-xs font-medium lowercase text-wrap text-accent/50')}>{children}</p>
        </div>
    )
}